import {action, makeObservable, observable} from "mobx";
import {GameInfo} from "../games/game-info";
import {GamesMap} from "../games/games.service.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {ServiceBase} from "../ServiceBase";
import {VideoSlideRenderer} from "./video-slides-renderers/video-slide.renderer";
import {ISlideRenderer, IVideoSlidesService} from "./video-slides.service.interface";

export class VideoSlidesService extends ServiceBase implements IVideoSlidesService {
    constructor(services: IServiceFactoryExtended) {
        super(services);

        this.reaction(() => this.services.games.gamesMap,
            (gamesMap) => {
                this.initGamesWithHardCodedVideoUrl(gamesMap);
            });
        makeObservable(this);
    }


    @observable
    private _slideList: ISlideRenderer[] = [];
    get slideList(): ISlideRenderer[] {
        return this._slideList;
    }

    gamesWithHardCodedVideoUrl: GameInfo[] = [];

    private initGamesWithHardCodedVideoUrl(gamesMap: GamesMap): void {
        console.log(gamesMap);
        this.gamesWithHardCodedVideoUrl.push(this.services.games.gamesMap[130083]);
        this.gamesWithHardCodedVideoUrl.push(this.services.games.gamesMap[130172]);
        this.gamesWithHardCodedVideoUrl.push(this.services.games.gamesMap[130002]);
        // this.gamesWithHardCodedVideoUrl.push(this.services.games.gamesMap[130003]);
        // this.gamesWithHardCodedVideoUrl.push(this.services.games.gamesMap[130100]);
        // this.gamesWithHardCodedVideoUrl.push(this.services.games.gamesMap[2341206]);
        let seedLoadedSlides = Array.from({length: 10}).map((_, index) => `Slide ${index + 1}`);
        seedLoadedSlides.forEach(seedSlide => this._pushSlide(seedSlide));
    }

    @action
    private _pushSlide(index: string) {
        let uniqueKey = this.services.tools.getGuid();
        let currentGameInfo = this.getRandomVideo(this.gamesWithHardCodedVideoUrl);
        let currentVideoSlideRenderer = new VideoSlideRenderer(uniqueKey, currentGameInfo);
        this._slideList.push(currentVideoSlideRenderer);

        //Keep this for multiple renderer
        // if (Math.random() < 0.5) {
        //     let currentGameInfo = this.getRandomVideo(this.gamesWithHardCodedVideoUrl);
        //     if (!Check.isNullOrUndefined(currentGameInfo)) {
        //         let currentVideoSlideRenderer = new VideoSlideRenderer(this.services.tools.getGuid(), currentGameInfo);
        //         this._slideList.push(currentVideoSlideRenderer);
        //     }
        // } else {
        //     let currentFreePlaySlideRenderer = new FreePlaySlideRenderer(uniqueKey);
        //     this._slideList.push(currentFreePlaySlideRenderer);
        // }
    }

    getRandomVideo = (gamesWithHardCodedVideoUrl: GameInfo[]): GameInfo | null => {
        if (gamesWithHardCodedVideoUrl.length === 0) {
            return null;
        }
        const randomPosition = Math.floor(Math.random() * gamesWithHardCodedVideoUrl.length);
        const gameWithHardCodedVideoUrl = gamesWithHardCodedVideoUrl[randomPosition];

        return gameWithHardCodedVideoUrl;
    };
}
